import * as React from 'react';

import DAT from '../assets/DAT-logo.png';

export default function DATLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={DAT} alt='DAT logo' height='12' width='75' {...props} />;
}
